import PropTypes from 'prop-types';
import React from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import { WHITE } from '@wetransfer/transfer/constant/colors';

export default class Notification extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onClose: PropTypes.func,
    showClose: PropTypes.bool,
  };

  static defaultProps = {
    showClose: false,
  };

  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);

    this.state = {
      shouldDisplay: true,
    };

    this.disableNotification = this.disableNotification.bind(this);
  }

  disableNotification() {
    this.setState({
      shouldDisplay: false,
    });

    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    if (!this.state.shouldDisplay) {
      return null;
    }

    const classNames = ['notification'];

    if (this.props.className) {
      classNames.push(this.props.className);
    }

    let onCloseComponent;

    if (this.props.showClose) {
      onCloseComponent = (
        <Icon
          type="Close"
          color={WHITE}
          className="notification__close"
          onClick={this.disableNotification}
        />
      );
    }

    return (
      <div className={classNames.join(' ')}>
        <div className="notification__content">{this.props.children}</div>
        {onCloseComponent}
      </div>
    );
  }
}
